export const mockSeries = [
  {
    type: 'spline',
    name: '',
    data: [
      797778.799109717,
      864549.1565487178,
      924475.8450322626,
      977103.1265441114,
      1023185.0011167554,
      1101697.4234716184,
      1179885.0335124952,
      1246202.59807562,
      1328143.230942691,
      1386736.5841298497,
      1479652.4974590905,
      1562316.7460238044,
      1677449.3096274708,
      1776642.996720334,
      1870290.2966498805,
      1979745.9058514044,
      2122653.3993462417,
      2245997.00901917,
      2395419.999386838,
      2535809.8403585246,
      2644068.551978291,
      2766683.53547701,
      2890593.4614484366,
      3030191.627672947,
      3168721.874734304,
      3275942.706599797,
      3410647.5374557637,
      3535865.36854013,
      3715001.3700445914,
      3780911.1340534827,
      3801275.6827485217,
      3845321.7896320224,
      3909066.664724999,
      4008846.551056374,
      4092753.3493229407,
      4058225.0567859574,
      4045434.481005573,
      3989930.177217284,
      3904980.687594349,
      3740496.186134571,
      3657917.757128779,
      3699366.9431085205,
      3548520.615870972,
      3477068.0707290224,
      3420067.83973049,
      3308191.049940408,
      3213613.068822316,
      3058767.2543002977,
      3006777.5967886047,
      2954257.1866803654,
      2842079.024151573,
      2761228.8841545815,
      2647233.163977495,
      2583947.4755578674,
      2554031.4044426247,
      2580338.825344746,
      2531013.959207732,
      2481073.0571547244,
      2461499.9139499436,
    ],
  },
  {
    type: 'spline',
    name: '',
    data: [
      808083.0861175423,
      867907.9841338414,
      912979.3164425695,
      960349.9159797318,
      1031771.3463240617,
      1112536.0692903884,
      1188051.4426376903,
      1247048.8222838163,
      1319645.6494874612,
      1415041.6870858497,
      1493506.2377551605,
      1578370.1675320747,
      1672204.3244000203,
      1785281.0647914633,
      1886278.4112206083,
      1980372.9434135042,
      2110527.6024066457,
      2224071.877657688,
      2340175.569598348,
      2443012.925784911,
      2567999.554823952,
      2713472.13728974,
      2844066.9279557006,
      2976008.3853997346,
      3126860.3327070796,
      3251745.901195221,
      3395514.169173288,
      3518893.0821625153,
      3663283.927850268,
      3734549.1729649375,
      3756212.1537829665,
      3837012.9586101323,
      3902502.64323463,
      3990461.748085648,
      4032558.1999318255,
      4037479.4989922964,
      3916629.3022024827,
      3864857.759206281,
      3788335.8752777553,
      3719322.8493647235,
      3664774.776373416,
      3670944.710384799,
      3628755.6502508987,
      3607168.8269922556,
      3507670.900321303,
      3302816.6101494245,
      3269004.760444413,
      3200697.3608327704,
      3022865.141522615,
      2959346.7428708593,
      2948454.284590009,
      2917632.0785140917,
      2880438.2501668558,
      2835150.148324628,
      2887181.5821670676,
      2919576.6839819774,
      2845909.111207151,
      2824642.8853567196,
      2576116.2674450856,
    ],
  },
  {
    type: 'spline',
    name: '',
    data: [
      836161.2832003335,
      878581.9897881701,
      913896.961301807,
      984523.4270550386,
      1052193.3226465005,
      1122732.654635524,
      1207105.9637521885,
      1283858.0268687892,
      1349499.792248498,
      1427147.7195401958,
      1504376.9874307206,
      1620015.2593433673,
      1730242.8854196814,
      1847733.053167149,
      1969764.4973805947,
      2127753.505449566,
      2214460.5652093277,
      2327778.4845164428,
      2402495.293229998,
      2525286.112540878,
      2646934.5647443556,
      2764285.6306743016,
      2919730.316735642,
      3092636.9204202974,
      3170001.823796637,
      3328069.483176244,
      3498792.2650122754,
      3660348.816893156,
      3793449.0491179377,
      3857214.338298782,
      3953276.597637978,
      3994980.2439351594,
      3992402.325364841,
      4022882.503118021,
      4039008.0227076346,
      3939347.3997806236,
      3885988.609325648,
      3832424.9758251887,
      3780895.918490751,
      3678688.4512525043,
      3640646.782699595,
      3570950.124513777,
      3531347.5803305274,
      3482338.2031018334,
      3458574.9960053316,
      3367652.2879476575,
      3289168.983496438,
      3285264.5932078725,
      3243737.507276797,
      3205686.0463995277,
      3176347.842705282,
      3216017.3029169724,
      3146381.2937238626,
      3040652.534219454,
      3172915.193081867,
      2955443.3064086186,
      2858718.71545096,
      2727935.5730600692,
      2698008.290685692,
    ],
  },
] as any;

export const mockCategories = [
  '37/32',
  '38/33',
  '39/34',
  '40/35',
  '41/36',
  '42/37',
  '43/38',
  '44/39',
  '45/40',
  '46/41',
  '47/42',
  '48/43',
  '49/44',
  '50/45',
  '51/46',
  '52/47',
  '53/48',
  '54/49',
  '55/50',
  '56/51',
  '57/52',
  '58/53',
  '59/54',
  '60/55',
  '61/56',
  '62/57',
  '63/58',
  '64/59',
  '65/60',
  '66/61',
  '67/62',
  '68/63',
  '69/64',
  '70/65',
  '71/66',
  '72/67',
  '73/68',
  '74/69',
  '75/70',
  '76/71',
  '77/72',
  '78/73',
  '79/74',
  '80/75',
  '81/76',
  '82/77',
  '83/78',
  '84/79',
  '85/80',
  '86/81',
  '87/82',
  '88/83',
  '89/84',
  '90/85',
  '91/86',
  '—/87',
  '—/88',
  '—/89',
  '—/90',
  '—/91',
];
